import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiala-icon",
  "use": "icon-xiala-icon-usage",
  "viewBox": "0 0 14 8.617",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8.617\" id=\"icon-xiala-icon\">\r\n  <rect id=\"icon-xiala-icon_矩形_3278\" data-name=\"矩形 3278\" width=\"9.9\" height=\"2.287\" rx=\"0.5\" transform=\"translate(14 1.617) rotate(135)\" fill=\"#dbdbdb\" />\r\n  <rect id=\"icon-xiala-icon_矩形_3279\" data-name=\"矩形 3279\" width=\"9.898\" height=\"2.282\" rx=\"0.5\" transform=\"translate(1.613 0.002) rotate(45)\" fill=\"#dbdbdb\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol